import Icon from "../../Icon"

import "./ListViewToggle.less"

const options = [
  { icon: "table_view", value: "table" },
  { icon: "cards_view", value: "cards" }
]

const ListViewToggle = ({ view, setView }) => {
  return (
    <div className="list-view-toggle">
      {options.map((option) => (
        <button
          key={option.value}
          className={`toggle-option ${view === option.value ? "active" : ""}`}
          onClick={() => setView(option.value)}
          type="button"
        >
          <Icon type={option.icon} />
        </button>
      ))}
    </div>
  )
}

export default ListViewToggle
